import React, { useContext } from 'react';
import DefaultLayout from '../../DefaultLayout/DefaultLayout';
import ContentBox from '../../common/ContentBox/ContentBox';
import { AppContext } from '../../../App.context';
import styles from './Sftp.styles';
import useSftpHook from './Sftp.hook';
import { Input, Divider, Select } from 'antd';
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';
import SaveButton from 'Components/common/SaveButton/SaveButton';
import Loading from 'Components/common/Loader/Loading';
import RequestSuscription from 'Components/common/RequestSuscription/RequestSuscription.jsx';
import { show2FAModal } from 'Components/common/TwoFactorModal/TwoFactorModal';

export default function Sftp() {
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);

  const { state, actions } = useSftpHook();
  if (!state?.subscription) {
    return (
      <DefaultLayout>
        <RequestSuscription suscription="sftp" />
      </DefaultLayout>
    );
  }
  return (
    <DefaultLayout>
      <ContentBox title={translate('sftp.configTitle')}>
        <div style={{ marginTop: '16px' }}>
          <b style={styles.confTitle}>{translate('sftp.description')}</b>
        </div>
        <div style={styles.credentialsContainer}>
          <div style={styles.inputContainer}>
            <b style={styles.header}>{translate('policeReport.ftpHost')}</b>
            <Input
              bordered={false}
              value={state.ftpHost || ''}
              onChange={e => actions.setField('ftpHost', e.target.value)}
              disabled={state.isLoading}
              style={{ backgroundColor: '#f5f5f5' }}
            />
          </div>
          <div style={styles.port}>
            <b style={styles.header}>{translate('sftp.protocol')}</b>
            <Select
              bordered={false}
              value={state.ftpProtocol || 'sftp'}
              onChange={value => actions.setField('ftpProtocol', value)}
              disabled={state.isLoading}
              style={{ backgroundColor: '#f5f5f5', width: '100%' }}
              options={[
                { value: 'ftp', label: 'FTP' },
                { value: 'sftp', label: 'SFTP' },
                { value: 'ftps', label: 'FTPS' },
              ]}
            />
          </div>

          <div style={styles.port}>
            <b style={styles.header}>{translate('policeReport.ftpPort')}</b>
            <Input
              bordered={false}
              value={state.ftpPort || ''}
              onChange={e => actions.setField('ftpPort', e.target.value)}
              disabled={state.isLoading}
              style={{ backgroundColor: '#f5f5f5' }}
            />
          </div>
        </div>

        <div style={styles.credentialsContainer}>
          <div style={styles.inputContainer}>
            <b style={styles.header}>{translate('policeReport.ftpUser')}</b>
            <Input
              bordered={false}
              value={state.ftpUser || ''}
              onChange={e => actions.setField('ftpUser', e.target.value)}
              disabled={state.isLoading}
              style={{ backgroundColor: '#f5f5f5' }}
            />
          </div>
          <div style={styles.inputContainer}>
            <b style={styles.header}>{translate('policeReport.ftpPass')}</b>
            <Input.Password
              bordered={false}
              value={state.ftpPass || ''}
              onChange={e => actions.setField('ftpPass', e.target.value)}
              disabled={state.isLoading}
              style={{ backgroundColor: '#f5f5f5' }}
              visibilityToggle={appState.superUser} // cant see info of field for non admin users
            />
          </div>
        </div>

        <div style={styles.buttonContainer}>
          {state.isLoading && <Loading size={'small'} />}
          <AppButton
            text={translate('policeReport.checkConnection')}
            secondary
            action={() => actions.checkConnections()}
            disabled={state.isLoading}
          />
          <div styles={styles.saveButtonContainer}>
            <SaveButton
              action={async applyToAll => {
                const twoFAResult = await show2FAModal();

                if (twoFAResult === true) {
                  await actions.onSavePressed(applyToAll);
                }
              }}
              text={translate('save')}
            />
          </div>
        </div>

        {state.connectionErrorMessage && (
          <p style={{ color: 'red' }}>Error: {state.connectionErrorMessage}</p>
        )}
      </ContentBox>
    </DefaultLayout>
  );
}
